module.exports = __webpack_public_path__ + "img/cross.c0d336d1.svg";